export default __webpack_public_path__ + "static/media/twitter-icon.62310280.svg";